<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>话术管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.title" autocomplete="off" maxlength="30" placeholder="话术标题"
							clearable @change="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange" size="mini">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增话术</el-button>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="sort" label="排序" align="center" />
			<el-table-column prop="title" label="话术标题" align="center" />
			<el-table-column prop="content" label="话术内容" align="center" width="200" />
			<el-table-column prop="copy_count" label="复制次数" align="center" />
			<el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center" width="260">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="话术标题" prop="title">
							<el-input v-model="form.title" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="话术内容" prop="content">
							<el-button round :disabled="disableSalerName" @click="insertPlaceholder('{staffName}')">插入销售占位</el-button>
							<el-button round :disabled="disableShortLink" @click="insertPlaceholder('{url}')">插入短链占位</el-button>
							<el-button round :disabled="disablePhone" @click="insertPlaceholder('{staffPhone}')">插入电话占位</el-button>
							<el-input ref="contentRef" v-model="form.content" @blur="contentBlur" type="textarea"
								rows="8" autocomplete="off" style="margin-top: 10px;" placeholder="请输入内容" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="标签" prop="tag_ids">
							<el-select v-model="form.tag_ids" placeholder="请选择" style="width: 100%"
								@change="getCategory" filterable multiple>
								<el-option v-for="item in tagGroup.tags" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="使用场景" prop="use_for">
							<el-select v-model="form.use_for" placeholder="请选择" style="width: 100%"
								@change="getCategory" filterable multiple>
								<el-option v-for="item in tagGroup.use_for" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="复制次数" prop="copy_count">
							<el-input v-model="form.copy_count" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getarticleList,
		addArticle,
		editArticle,
		deleteCity,
	} from "../../api/script";

	import {
		huaShuTagSeleList
	} from "../../api/labelChild";


	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getarticleList,
					add: addArticle,
					del: deleteCity,
					edit: editArticle,
				},
				// 规则验证
				rules: {
					title: [{
						required: true,
						message: "请输入名称",
						trigger: "blur"
					}],
					content: [{
						required: true,
						message: "请输入内容",
						trigger: "blur"
					}],
					tag_ids: [{
						required: true,
						message: "请选择标签",
						trigger: "change"
					}],
					use_for: [{
						required: true,
						message: "请选择使用场景",
						trigger: "change"
					}],
					status: [{
						required: true,
						message: "请选择",
						trigger: "change"
					}],
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
				},
				tableData: [],
				// 标签下拉列表
				tagGroup: {},
				disableSalerName: false,
				disableShortLink: false,
				disablePhone: false,
				focusIndex: 0,
			};
		},
		mounted() {
			this.labelChildLists();
		},
		methods: {
			insertPlaceholder(insertTxt) {
				if (!this.form.content) {
					this.form.content = ''
				}
				this.form.content = this.form.content.slice(0, this.focusIndex) + insertTxt + this.form.content.slice(
					this.focusIndex);
				this.$refs.contentRef.focus();
				this.$nextTick(() => {
					var input = this.$refs.contentRef.$refs.textarea
					if (input) {
						input.setSelectionRange(this.focusIndex + insertTxt.length,this.focusIndex + insertTxt.length)
					}
				})
			},
			contentBlur(e) {
				this.focusIndex = e.srcElement.selectionStart;
			},
			// 标签下拉
			labelChildLists() {
				const select = {
					select: 1,
					type: 4,
				};
				huaShuTagSeleList(select).then((res) => {
					this.tagGroup = res.data;
				});
			},
			// 改变状态
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				this.actionType = "edit";

				editArticle(this.form).then((msg) => {
					if (msg.code !== 200) return this.$message("获取状态失败");
				});
			},
			getCategory(res) {},
			// 重置
			reset() {
				this.form = {
					title: '',
					content: '',
				};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
				this.$nextTick(() => {
					this.form.type = 4;
					this.form.status = 1;
					this.$refs.form.clearValidate();
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				console.log('行修改点击：', this.form);
				if (this.form.use_for) {
					const stt = this.form.use_for.split(",").map(Number);
					this.form.use_for = stt;
				}
				if (this.form.tag_ids) {
					const stts = this.form.tag_ids.split(",").map(Number);
					this.form.tag_ids = stts;
				}

				this.handleEdit();
			},
			// 点击确定
			submitForms() {

				if (this.form.use_for) {
					const str = this.form.use_for.join(",");
					this.form.use_for = str;
				}
				if (this.form.tag_ids) {
					const strs = this.form.tag_ids.join(",");
					this.form.tag_ids = strs;
				}
				try {
					// 提交表单
					this.submitForm(this.form.category_ids);
				} catch (error) {
					// 处理提交失败的情况
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭复制弹窗
			copyout() {
				this.copyIf = false;
				this.$refs.copyForm.clearValidate();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 6vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/information/script.vue